import React from "react";
import { EntryStatus } from "../../../types";
import { StatusBadge } from "../../../components/ui/StatusBadge";

export function BulkBar({
  selectedCount,
  onSetStatus,
  onClearSelection,
}: {
  selectedCount: number;
  onSetStatus: (s: EntryStatus) => void;
  onClearSelection: () => void;
}) {
  if (!selectedCount) return null;
  return (
    <div className="sticky top-14 z-20 mb-3 flex items-center gap-2 rounded-2xl border border-blue-200 bg-blue-50 p-2 text-sm shadow-sm">
      <span className="ml-1">{selectedCount} selezionate</span>
      <div className="ml-2 flex items-center gap-2">
        {(["Registra", "Ignora"] as EntryStatus[]).map((s) => (
          <button
            key={s}
            onClick={() => onSetStatus(s)}
            className="rounded-xl border border-blue-200 bg-white px-2.5 py-1.5 hover:bg-blue-50"
          >
            <StatusBadge status={s} />
          </button>
        ))}
      </div>
      <button onClick={onClearSelection} className="ml-auto rounded-xl px-2 py-1 text-gray-600 hover:bg-blue-100">
        Annulla
      </button>
    </div>
  );
}
